import { render, staticRenderFns } from "./TrafficMessageForecastText.vue?vue&type=template&id=5c49a890"
import script from "./TrafficMessageForecastText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageForecastText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports